import Tooltip from '@/UIComponents2/Tooltip'
import { useViewMode } from '../shared/useViewMode'

type SidebarTooltipProps = React.ComponentProps<typeof Tooltip>

export function SidebarTooltip(props: SidebarTooltipProps) {
    const viewMode = useViewMode()

    const forceNative = viewMode.sidebarCollapsed || viewMode.galleryHidden || viewMode.sidebarPoppedOut

    return <Tooltip {...props} forceNative={forceNative} />
}
